// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GAzSY","label":"styles_label__1dnGr"};